export const name = "FLOOR";
export const summary = `Gets the largest integral value that isn't greater than \`X\`.`;
export const reference = `
## FLOOR

Gets the largest integral value that isn't greater than \`X\`.

\`\`\`
FLOOR(X)
\`\`\`

### Description

Returns the largest integral value that isn't greater than X.

| X | FLOOR(X) |
| --- | --- |
| 2.0 | 2.0 |
| 2.3 | 2.0 |
| 2.8 | 2.0 |
| 2.5 | 2.0 |
| -2.3 | -3.0 |
| -2.8 | -3.0 |
| -2.5 | -3.0 |
| 0 | 0 |
| \`+inf\` | \`+inf\` |
| \`-inf\` | \`-inf\` |
| \`NaN\` | \`NaN\` |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`FLOAT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
